import { type ComponentProps } from 'react';
import { styled } from '@lingoda/ui';

interface LingodaLogoIconProps {
    sx?: ComponentProps<typeof SvgStyled>['sx'];
}

export const LingodaLogoIcon = (props: LingodaLogoIconProps) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 102 102"
            fill="currentColor"
            {...props}
        >
            <path d="M75.594 102C87.494 102 97 92.49 97 80.456c0-11.96-9.505-21.47-21.406-21.47-12.125 0-21.48 9.51-21.48 21.47 0 12.11 9.505 21.544 21.48 21.544M54.712 32.539C54.712 13.001 43.485 0 26.346 0 11.9 0 0 11.812 0 26.447 0 40.414 9.505 51.78 22.903 53.786 26.72 69.98 17.065 92.342 4.715 96.8c-1.197.371-1.646.817-1.646 1.931 0 .892.823 1.635 2.694 1.486 12.424-.52 27.02-12.332 37.198-27.933 7.41-11.366 11.751-25.853 11.751-39.745" />
        </SvgStyled>
    );
};

const SvgStyled = styled('svg')(({ theme }) => ({
    flexShrink: 0,
    display: 'block',
    width: '100%',
    height: 'auto',
    // Default spacing around the logo enforced by brand guidelines
    padding: '22%',
    aspectRatio: '1 / 1',
    color: theme.colors.brand.purple,
}));
